import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";
import KalitedenGecmeyen from "./KalitedenGecmeyen";

const VARDIYA = ["00:00 - 08:00", "08:00 - 16:00", "16:00 - 24:00"];
const BOLUM = ["Dekor", "Dijital", "Sırlama", "Logo"];
const kgVal = (adet, r) => Math.round((Number(adet) || 0) * (Number(r.urun_kg) || 0) * 10) / 10;

const TABS = [
  {
    id: "shaping", label: "Şekillenen Ürün", endpoint: "/entity/shaping", titleSingular: "Şekillendirme",
    warnEmptyKeys: ["aciklama", "makina"],
    warnEmptyMessage: "Bazı kayıtlarda Açıklama / Makina otomatik gelmedi — kalıp Malzemeler'de tanımlı değil.",
    bulkEditFields: ["vardiya", "sekillenen_adet", "defo_adet", "net_adet"],
    columns: [
      { key: "tarih", label: "Tarih" }, { key: "vardiya", label: "Vardiya" },
      { key: "kalip_kodu", label: "Kalıp Kodu", mono: true }, { key: "aciklama", label: "Açıklama" },
      { key: "makina", label: "Makina" }, { key: "uretim_sekli", label: "Üretim Şekli" },
      { key: "sekillenen_adet", label: "Şekillenen", num: true }, { key: "defo_adet", label: "Defo", num: true },
      { key: "net_adet", label: "Net", num: true },
      { key: "brut_sekillenen", label: "Brüt Şekillenen", num: true, value: (r) => (Number(r.sekillenen_adet) || 0) + (Number(r.defo_adet) || 0), render: (r) => (Number(r.sekillenen_adet) || 0) + (Number(r.defo_adet) || 0) },
      { key: "net_kg", label: "Net KG", num: true, value: (r) => kgVal(r.net_adet, r), render: (r) => kgVal(r.net_adet, r) },
      { key: "defo_kg", label: "Defo KG", num: true, value: (r) => kgVal(r.defo_adet, r), render: (r) => kgVal(r.defo_adet, r) },
      { key: "brut_kg", label: "Brüt Şekillenen KG", num: true, value: (r) => kgVal((Number(r.sekillenen_adet) || 0) + (Number(r.defo_adet) || 0), r), render: (r) => kgVal((Number(r.sekillenen_adet) || 0) + (Number(r.defo_adet) || 0), r) },
      { key: "defo_orani", label: "Defo Oranı", render: (r) => {
        const brut = (Number(r.sekillenen_adet) || 0) + (Number(r.defo_adet) || 0);
        const p = brut > 0 ? Math.round((Number(r.defo_adet) || 0) / brut * 1000) / 10 : 0;
        const cls = p >= 10 ? "bg-red-100 text-red-700" : p >= 5 ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700";
        return <span data-testid={`defo-orani-${r.id}`} className={`inline-block rounded px-2 py-0.5 text-xs font-bold ${cls}`}>%{p}</span>;
      } },
      { key: "hedef_kapasite", label: "Hedef Kapasite (Vardiya)", num: true, value: (r) => Math.round((Number(r.makina_kapasitesi) || 0) / 3), render: (r) => (Number(r.makina_kapasitesi) || 0) > 0 ? Math.round((Number(r.makina_kapasitesi) || 0) / 3).toLocaleString("tr-TR") : "—" },
      { key: "kapasite_orani", label: "Kapasite Oranı", render: (r) => {
        const h = (Number(r.makina_kapasitesi) || 0) / 3;
        if (h <= 0) return <span className="text-zinc-400 text-xs">kapasite yok</span>;
        const p = Math.round((Number(r.net_adet) || 0) / h * 1000) / 10;
        const cls = p >= 100 ? "bg-emerald-100 text-emerald-700" : p >= 70 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700";
        return <span data-testid={`kapasite-orani-${r.id}`} className={`inline-block rounded px-2 py-0.5 text-xs font-bold ${cls}`}>%{p}</span>;
      } },
    ],
    fields: [
      { key: "tarih", label: "Tarih", type: "date", required: true },
      { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
      { key: "kalip_kodu", label: "Kalıp Kodu", type: "kalipkodu", required: true, span: 2, fills: { aciklama: "aciklama", makina: "makina", uretim_sekli: "uretim_sekli" } },
      { key: "aciklama", label: "Açıklama (otomatik)", type: "text", readOnly: true, span: 2 },
      { key: "makina", label: "Makina (otomatik)", type: "text", readOnly: true },
      { key: "uretim_sekli", label: "Üretim Şekli (otomatik)", type: "text", readOnly: true },
      { key: "sekillenen_adet", label: "Şekillenen Adet", type: "number", required: true },
      { key: "defo_adet", label: "Defo Adedi", type: "number" },
      { key: "net_adet", label: "Net (Silim) Adet", type: "number" },
    ],
  },
  {
    id: "biscuit", label: "Bisküvi Giriş", endpoint: "/entity/biscuit", titleSingular: "Bisküvi Giriş",
    warnEmptyKeys: ["aciklama"],
    warnEmptyMessage: "Bazı kayıtlarda Açıklama otomatik gelmedi — kalıp Malzemeler / Bisküvi Stok'ta tanımlı değil.",
    bulkEditFields: ["vardiya", "kalite1", "defolu", "kirik", "toplam", "kg"],
    columns: [
      { key: "tarih", label: "Tarih" }, { key: "vardiya", label: "Vardiya" },
      { key: "kalip_kodu", label: "Kalıp Kodu", mono: true }, { key: "aciklama", label: "Açıklama" },
      { key: "kalite1", label: "1.Kalite", num: true }, { key: "defolu", label: "Defolu", num: true },
      { key: "kirik", label: "Kırık", num: true }, { key: "toplam", label: "Toplam", num: true },
      { key: "kg", label: "KG", num: true },
    ],
    fields: [
      { key: "tarih", label: "Tarih", type: "date", required: true },
      { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
      { key: "kalip_kodu", label: "Kalıp Kodu", type: "kalipkodu", required: true, span: 2, fills: { aciklama: "aciklama" } },
      { key: "aciklama", label: "Açıklama (otomatik)", type: "text", readOnly: true, span: 2 },
      { key: "kalite1", label: "1. Kalite", type: "number", required: true },
      { key: "defolu", label: "Bisküvi Defolu", type: "number" },
      { key: "kirik", label: "Bisküvi Kırık", type: "number" },
      { key: "toplam", label: "Toplam Bisküvi", type: "number" },
      { key: "kg", label: "KG Ağırlık", type: "number" },
    ],
  },
  {
    id: "finished", label: "Yapılan Ürün", endpoint: "/entity/finished", titleSingular: "Yapılan Ürün",
    warnEmptyKeys: ["kalip_kodu", "renk"],
    warnEmptyMessage: "Bazı kayıtlarda Kalıp Kodu / Renk otomatik gelmedi — ürün Malzemeler'de tanımlı değil.",
    bulkEditFields: ["vardiya", "bolum", "logolanan", "kalite1", "fire", "toplam", "kg"],
    columns: [
      { key: "tarih", label: "Tarih" }, { key: "vardiya", label: "Vardiya" },
      { key: "bolum", label: "Bölüm" },
      { key: "urun_kodu", label: "Ürün Kodu", mono: true }, { key: "renk", label: "Renk" },
      { key: "logolanan", label: "Logolanan", num: true }, { key: "kalite1", label: "1.Kalite", num: true },
      { key: "fire", label: "Fire", num: true }, { key: "toplam", label: "Toplam", num: true },
      { key: "kg", label: "KG", num: true },
    ],
    fields: [
      { key: "tarih", label: "Tarih", type: "date", required: true },
      { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
      { key: "bolum", label: "Bölüm", type: "select", options: BOLUM },
      { key: "urun_kodu", label: "Ürün Kodu", type: "product", required: true, span: 2, fills: { kalip_kodu: "kalip_kodu", renk: "renk", aciklama: "aciklama" } },
      { key: "kalip_kodu", label: "Kalıp Kodu (otomatik)", type: "text", readOnly: true, mono: true },
      { key: "renk", label: "Renk (otomatik)", type: "text", readOnly: true },
      { key: "logolanan", label: "Logolanan Adet", type: "number" },
      { key: "kalite1", label: "1. Kalite Yapılan Ürün", type: "number", required: true },
      { key: "fire", label: "Fire", type: "number" },
      { key: "toplam", label: "Toplam Yapılan Ürün", type: "number" },
      { key: "kg", label: "Toplam KG", type: "number" },
    ],
  },
  {
    id: "kaliteden_gecmeyen", label: "Kaliteden Geçmeyen Ürünler", custom: true,
  },
  {
    id: "kiln", label: "Bisküvi Fırını Yükleme", endpoint: "/entity/kiln", titleSingular: "Fırın Yükleme",
    warnEmptyKeys: ["aciklama"],
    warnEmptyMessage: "Bazı kayıtlarda Açıklama otomatik gelmedi — kalıp Malzemeler'de tanımlı değil.",
    bulkEditFields: ["vardiya", "yuklenen_saat", "yuklenen_adet", "vagon_no", "yukleme_personel", "notu"],
    columns: [
      { key: "tarih", label: "Tarih" }, { key: "vardiya", label: "Vardiya" },
      { key: "yuklenen_saat", label: "Yüklenen Saat", mono: true },
      { key: "kalip_kodu", label: "Kalıp Kodu", mono: true }, { key: "aciklama", label: "Açıklama" },
      { key: "yuklenen_adet", label: "Yüklenen Adet", num: true },
      { key: "vagon_no", label: "Vagon No" },
      { key: "yukleme_personel", label: "Yükleme Yapan Personel" },
      { key: "notu", label: "Not" },
    ],
    fields: [
      { key: "tarih", label: "Tarih", type: "date", required: true },
      { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
      { key: "yuklenen_saat", label: "Yüklenen Saat", type: "time", required: true },
      { key: "kalip_kodu", label: "Kalıp Kodu", type: "kalipkodu", required: true, span: 2, fills: { aciklama: "aciklama" } },
      { key: "aciklama", label: "Açıklama (otomatik)", type: "text", readOnly: true, span: 2 },
      { key: "yuklenen_adet", label: "Yüklenen Adet", type: "number", required: true },
      { key: "vagon_no", label: "Vagon No", type: "text" },
      { key: "yukleme_personel", label: "Yükleme Yapan Personel", type: "text", span: 2 },
      { key: "notu", label: "Not", type: "text", span: 2 },
    ],
  },
];

export default function Production() {
  const [searchParams] = useSearchParams();
  const initialTab = TABS.find((t) => t.id === searchParams.get("tab"))?.id || TABS[0].id;
  const [tab, setTab] = useState(initialTab);
  const active = TABS.find((t) => t.id === tab);
  return (
    <>
      <PageHeader title="Üretim Girişi" subtitle="Şekillendirme, bisküvi ve yapılan ürün kayıtları" />
      <div className="px-6 pt-4">
        <div className="flex gap-1 border-b border-zinc-200">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`tab-${t.id}`}
              className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                tab === t.id ? "border-amber-600 text-amber-700" : "border-transparent text-zinc-500 hover:text-zinc-800"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {active.custom ? (
        <div className="px-6 pt-4">
          <KalitedenGecmeyen />
        </div>
      ) : (
        <CrudTable key={active.id} endpoint={active.endpoint} columns={active.columns} fields={active.fields}
          titleSingular={active.titleSingular} dateField="tarih" vardiyaFilter exportKind={active.id}
          bulkEditFields={active.bulkEditFields}
          warnEmptyKeys={active.warnEmptyKeys} warnEmptyMessage={active.warnEmptyMessage} />
      )}
    </>
  );
}
